import { render, staticRenderFns } from "./OptionsTrucks.vue?vue&type=template&id=75db56cb&scoped=true"
import script from "./OptionsTrucks.vue?vue&type=script&lang=js"
export * from "./OptionsTrucks.vue?vue&type=script&lang=js"
import style0 from "./OptionsTrucks.vue?vue&type=style&index=0&id=75db56cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75db56cb",
  null
  
)

export default component.exports